import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() toggleSideBarEmitter: EventEmitter<any> = new EventEmitter();

  constructor(public afAuth: AngularFireAuth) {}

  ngOnInit(): void {}

  toggleSideBar(): void {
    this.toggleSideBarEmitter.emit();
  }

}
